import { createSlice } from "@reduxjs/toolkit";
import { ILifePlanRate, IShelfPlanAdminCost, IShelfPlanInformation } from "components/life/shelfPlans/information/Information.interface";
import { ILifePlanServiceRateConfiguration } from "container/life/planSetup/b2c/shelfPlans/services/shelfPlanService.interface";
import { RootState } from "redux/store";
import { SALE_POINTS } from "shared/constant";
import { IListOfValues } from "shared/interface/types";

interface ILifeInitialState {
  ShelfPlan: IShelfPlanInformation;
  ActivePriceSalePoint: keyof typeof SALE_POINTS;
  ShelfPlanAdminCost: IShelfPlanAdminCost;
  LifePlanRateConfiguration: ILifePlanRate[];
  LifePlanActivePlans: string[];
  LifePlanService: {
    id: string;
    lifePlanServiceRateConfiguration?: ILifePlanServiceRateConfiguration[];
    service?: { contribution: IListOfValues; id: number; name: string };
  };
}
const initialState: ILifeInitialState = {
  ShelfPlan: {
    lifePlanGenders: [],
    planTypeId: 0,
    priceTypeId: 0,
    id: "",
    takafulProviderId: 0,
    productName: "",
    salePoint: [],
    renewalMinAge: 0,
    renewalMaxAge: 0
  },
  LifePlanService: {
    id: ""
  },
  ActivePriceSalePoint: "",
  ShelfPlanAdminCost: {
    adminCostMax: 0,
    adminCostMaxTypeId: 0,
    adminCostMin: 0,
    adminCostMinTypeId: 0
  },
  LifePlanRateConfiguration: [],
  LifePlanActivePlans: []
};

const lifeSlice = createSlice({
  name: "life",
  initialState,
  reducers: {
    AddLifeShelfPlan: (state, action) => {
      state.ShelfPlan = action.payload;
    },
    AddLifePlanService: (state, action) => {
      state.LifePlanService = action.payload;
    },
    DeleteLifeShelfPlan: state => {
      state.ShelfPlan = initialState.ShelfPlan;
    },
    UpdateActiveSalePoint: (state, action) => {
      state.ActivePriceSalePoint = action.payload;
    },
    UpdateAdminCostForShelfPlanPrice: (state, action) => {
      state.ShelfPlanAdminCost = action.payload;
    },
    UpdateLifePlanRateConfiguration: (state, action) => {
      state.LifePlanRateConfiguration = action.payload;
    },
    UpdateLifeActivePlan: (state, action) => {
      state.LifePlanActivePlans = action.payload;
    }
  }
});

export const {
  AddLifeShelfPlan,
  DeleteLifeShelfPlan,
  UpdateActiveSalePoint,
  UpdateAdminCostForShelfPlanPrice,
  UpdateLifePlanRateConfiguration,
  UpdateLifeActivePlan,
  AddLifePlanService
} = lifeSlice.actions;
export default lifeSlice.reducer;

export const getLifeShelfPlan = (state: RootState): ILifeInitialState => state.life;
